import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import './index.css';
import App from './App';
import About from './About';
import Home from './Home';
import Works from './Works';

import Gallery from './Gallery';
import Detail from './Detail';
import GalleryList from './GalleryList';

import OC from './OC';
import OCList from './OCList';
import World from './World';

const router = createBrowserRouter([
  {
  path: "/",
  element: <App />,
  children: [
    {
      index: true,
      element: <Navigate replace to='/Home'/>
    },
    {
      path: "Home",
      element: <Home />
    },
    {
      path: "About",
      element: <About />
    },
    {
      path: "Works",
      element: <Works />
    },
    {
      path: "OC",
      element: <OC />,
      children: [
        {
          index: true,
          element: <OCList />
        },
        {
          path: ":worldName",
          element: <World />,
        }
      ]
    },
    {
      path: "Gallery",
      element: <Gallery />,
      children: [
        {
          index: true,
          element: <GalleryList />
        },
        {
          path: ":artName",
          element: <Detail />
        }
      ]
    },
  ]
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
